import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchPartsByCampaignNo = (parameters = {}) =>
  apiActionCreator({
    'endpoint': `/campaing/part${getUrlParameters(parameters)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_PARTS_BY_CAMPAIGN,
      ActionTypes.FETCHED_PARTS_BY_CAMPAIGN,
      [
        ActionTypes.FETCHED_CAMPAIGN_PART_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const getCampaignPart = (part) =>
  apiActionCreator({
    'endpoint': `/campaing/part/${part}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_CAMPAIGN_PART,
      ActionTypes.FETCHED_CAMPAIGN_PART,
      [
        ActionTypes.FETCHED_CAMPAIGN_PART_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });


export const removeElementFromParts = (partsArray) =>
  apiActionCreator({
    'endpoint': '/campaing/part',
    'authenticated': true,
    'types': [
      ActionTypes.REMOVING_ELEMENT_FOR_CAMPAIGN_PARTS,
      [
        ActionTypes.REMOVED_ELEMENT_FOR_CAMPAIGN_PARTS,
        MessageActions.addMessageBoxInfo('Registro parte eliminado con exito'),
      ],
      [
        ActionTypes.REMOVED_ELEMENT_FOR_CAMPAIGN_PARTS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'contentType': 'application/json',
    'method': 'DELETE',
    'data': {partsArray},
  });

export const addElementToParts = (part) =>
  apiActionCreator({
    'endpoint': '/campaing/part',
    'authenticated': true,
    'types': [
      ActionTypes.ADDING_ELEMENT_FOR_CAMPAIGN_PARTS,
      [
        ActionTypes.ADDED_ELEMENT_FOR_CAMPAIGN_PARTS,
        MessageActions.addMessageBoxInfo('Registro parte agregado con exito'),
      ],
      [
        ActionTypes.ADDED_ELEMENT_FOR_CAMPAIGN_PARTS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'contentType': 'application/json',
    'method': 'POST',
    'data': part,
  });

export const changePartsMinStock = (index, value) => {
  return {
    'type': ActionTypes.CHANGE_PARTS_MIN_STOCK,
    'payload': {index, value},
  };
};
